import { Component, Inject, forwardRef } from '@angular/core';
import { DataTable } from './table.component';
import { HEADER_TEMPLATE } from './header.template';
import { HEADER_STYLE } from "./header.style";



export class DataTableHeader {

    columnSelectorOpen = false;

    _closeSelector() {
        this.columnSelectorOpen = false;
    }

    constructor( public dataTable: DataTable) {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'data-table-header',
  template: HEADER_TEMPLATE,
  styles: [HEADER_STYLE],
  host: {
    '(document:click)': '_closeSelector()'
  }
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DataTable, decorators: [{ type: Inject, args: [forwardRef(() => DataTable), ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
